module.exports = __webpack_public_path__ + "img/widdenp.fd19ea2b.jpg";